"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createIsValidTokenResponse = void 0;

var _genericAsResultHeader = require("../../../../utils/generic-as-result-header");

var _modelBuilders = require("../../../../utils/model-builders");

var _DataServerDate = require("../../../../types/DataServerDate");

/*
  Sample XML Response:
<?xml version="1.0" encoding="utf-8"?>
<soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
    <soap:Body>
        <IsValidTokenResponse xmlns="http://www.aperio.com/webservices/">
            <IsValidTokenResult>
                <ASResult>0</ASResult>
                <ASMessage></ASMessage>
                <ASDetails></ASDetails>
            </IsValidTokenResult>
            <Valid>True</Valid>
            <TokenExpirationTime>2018-03-18T13:19:41.567539-07:00</TokenExpirationTime>
        </IsValidTokenResponse>
    </soap:Body>
</soap:Envelope>
*/
var createIsValidTokenResponse = function createIsValidTokenResponse(raw) {
  var result = (0, _modelBuilders.parseKey)(raw, {
    path: 'IsValidTokenResult[0]',
    model: _genericAsResultHeader.genericAsResultHeader
  });
  var isValid = (0, _modelBuilders.parseKey)(raw, {
    path: 'Valid[0]',
    type: Boolean
  });
  var expires = (0, _modelBuilders.parseKey)(raw, {
    path: 'TokenExpirationTime[0]',
    type: _DataServerDate.DataServerDate
  });
  return {
    result: result,
    response: {
      isValid: isValid,
      expires: expires
    }
  };
};

exports.createIsValidTokenResponse = createIsValidTokenResponse;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/security/authentication/response-parsers/is-valid-token-response.js
// module id = 215
// module chunks = 0